'use client';
import { useEffect, useMemo, useState } from 'react';

import classes from './style.module.scss';

import { cn } from '@/lib/utils';
import useScrollSpy from '@/hooks/useScrollSpy';

import Glow from '../Glow';

export const bgColor = {
  yellow: 'yellow',
  green: 'green',
  red: 'red',
  gray: 'gray',
  purple: 'purple',
  transparent: 'transparent',
};

export default function BackgroundGlow() {
  const [color, setColor] = useState(bgColor.transparent);
  const [displayGlow, setDisplayGlow] = useState(false);
  const sections = useMemo(
    () => [
      {
        id: 'focus-areas-environment',
        color: bgColor.yellow,
      },
      {
        id: 'focus-areas-digital',
        color: bgColor.red,
      },
      {
        id: 'focus-areas-quantum',
        color: bgColor.gray,
      },
      {
        id: 'focus-areas-healthcare',
        color: bgColor.green,
      },
      {
        id: 'focus-areas-aerospace',
        color: bgColor.purple,
      },
    ],
    [],
  );
  const reduceToIds = sections.reduce((acc: string[], curr) => {
    acc.push(curr.id);

    return acc;
  }, []);
  const activeId = useScrollSpy(reduceToIds, 300);

  useEffect(() => {
    setDisplayGlow(activeId.length > 0);

    if (activeId.length > 0) {
      const section = sections.find((item) => item.id === activeId);

      section && setColor(section.color);
    } else {
      setColor(bgColor.transparent);
    }
  }, [activeId, sections]);

  return (
    <Glow
      className={cn(
        'applications-glow',
        'fixed -z-10 opacity-0',
        '-left-[30rem] -top-80 md:-left-[700px] md:-top-[700px] lg:-left-[500px] lg:-top-[404px] 2xl:-left-[800px] 2xl:-top-[800px]',
        displayGlow && 'display-glow',
        classes[color],
      )}
      type='custom'
    />
  );
}
